import type { AgentType } from 'features/trend-detection/types'

/** Parses the `?agent_type=` query param the list page's QuickCreateCards
 * hand off to `/agents/create` (see AgentCreatePage). Moved verbatim from
 * agent-list/Container.tsx's `parseAgentTypeParam`. */
export function parseAgentTypeParam(value: string | null): AgentType | null {
  if (
    value === 'issue_detection' ||
    value === 'benchmarking' ||
    value === 'general'
  ) {
    return value
  }
  return null
}
